import * as React from 'react';

export const CheckSymbol = () => (
  <svg viewBox="0 0 40 40" height="20" width="20" className="check-symbol">

    <g id="unchecked" >
      <path fill="#0067c5"
        // eslint-disable-next-line max-len
        d="M851.655,976.4a4.556,4.556,0,0,1,4.444,4.444v31.111a4.557,4.557,0,0,1-4.444,4.444H820.544a4.557,4.557,0,0,1-4.444-4.444V980.844a4.556,4.556,0,0,1,4.444-4.444Zm0,4.444H820.544v31.111h31.111Z" 
        transform="translate(-816.1 -976.4)"
      />
    </g>

    <g id="checked">
      <rect fill="#fff"  width="40" height="40" />
      <path fill="#0067c5"
        // eslint-disable-next-line max-len
        d="M38.525,3H7.441A4.453,4.453,0,0,0,3,7.441V38.525a4.453,4.453,0,0,0,4.441,4.441H38.525a4.453,4.453,0,0,0,4.441-4.441V7.441A4.453,4.453,0,0,0,38.525,3ZM18.543,34.084,7.441,23.408l3.109-2.987,7.994,7.686L35.418,11.884l3.106,2.987Z" 
        transform="translate(-2.965 -3)"
      />
    </g>
  </svg>
);
